import { createFileRoute } from "@tanstack/react-router";
import { getActivityAddPage } from "#/modules/beweegactiviteitenreeks/activities.functions";
import { BeweegactiviteitenreeksCrudPage } from "#/modules/beweegactiviteitenreeks/components/page.crud-beweegactiviteiten";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/activities/add/",
)({
  loader: () => getActivityAddPage(),
  component: SchoolActivityAddPage,
});

function SchoolActivityAddPage() {
  const loaderData = Route.useLoaderData();
  return (
    <BeweegactiviteitenreeksCrudPage
      beweegactiviteitenreeks={loaderData.beweegactiviteitenreeks}
      isEditRoute={loaderData.isEditRoute}
    />
  );
}
